import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import StudentLogo from '@/components/StudentLogo';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isAuthenticated, user, logout } = useAuth();
  const location = useLocation();

  // Hide header and footer during test taking
  const isTestTaking = location.pathname.includes('/test/') && location.pathname.includes('/take');

  if (isTestTaking) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <header className="bg-primary text-primary-foreground border-b border-blue-300">
        <div className="container mx-auto px-4 py-3 flex justify-between items-center">
          <Link to="/" className="flex items-center">
            <StudentLogo size="md" showText={true} textColor="white" />
          </Link>
          <nav className="flex items-center space-x-4">
            {isAuthenticated ? (
              <>
                <Link to="/" className="hover:text-blue-200 transition-colors text-sm font-medium">Dashboard</Link>
                <Link to="/tests" className="hover:text-blue-200 transition-colors text-sm font-medium">Tests</Link>
                <Link to="/analytics" className="hover:text-blue-200 transition-colors text-sm font-medium">Analytics</Link>
                <Link to="/profile" className="hover:text-blue-200 transition-colors text-sm font-medium">Profile</Link>
                <Button
                  size="sm"
                  onClick={logout}
                  className="bg-white/10 text-white border border-white/20 hover:bg-white/20 text-xs backdrop-blur-sm"
                >
                  Logout
                </Button>
                <span className="text-sm text-blue-100">Hi, {user?.username || 'Student'}</span>
              </>
            ) : (
              <Link to="/login">
                <Button size="sm" className="bg-white/10 text-white border border-white/20 hover:bg-white/20 text-xs backdrop-blur-sm">
                  Login
                </Button>
              </Link>
            )}
          </nav>
        </div>
      </header>
      <main className="flex-grow">
        {children}
      </main>
      <footer className="bg-gray-100 py-4 border-t border-gray-200">
        <div className="container mx-auto px-4 text-center text-muted-foreground">
          <p className="text-sm">&copy; {new Date().getFullYear()} BayesPrep Student Portal. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
